import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import KlaimForm from '../views/klaim/KlaimForm.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/klaim',
    name: 'klaim',
    component: KlaimForm,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/page',
    name: 'page',
    component: () => import('../views/template/PageTemplateView.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/dataDetail/:id?',
    name : 'dataDetail',
    component: ()=> import('../views/template/PageTemplateDetail.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/Login',
    name : 'Login',
    component: ()=> import('../views/login/formLogin.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/Map',
    name : 'Map',
    component: ()=> import('../views/maps/MapsForm.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to,from,next)=>{
  const isAuth =  JSON.parse(localStorage.getItem('isAuth')) 
  const kode =  localStorage.getItem('transporter_name') 
  if(to.meta.requiresAuth){
      console.log(isAuth);
      if(isAuth){
        if(kode == "AMA"){
          if (to.name === "Map") {
            next()
          }else{
            next("/Map")
          }
        }else{
          next()
        }
      }else{
        next("/Login")
        console.log('lahhhhhhh');
      }
  }else{
    if(to.name !== "Login"){
      next("/Login")
    }else{
      next()
    }
  }
})

export default router
